import { ca } from '@cian/analytics';
import { TRecentlyViewedOffer } from '../../types/recentlyViewedOffer';

export type TProduct = {
  offer: TRecentlyViewedOffer;
  position: number;
};

export function trackRecentlyViewedItemClick({ offer, position }: TProduct) {
  ca('eventSite', {
    name: 'oldevent',
    category: 'ListingFavorites',
    action: 'click',
    label: 'recent_offers',
    page: {
      pageType: 'ListingFavorites',
    },
    products: [
      {
        id: offer.offerId,
        offerType: 'offer',
        position,
      },
    ],
  });
}
